import React, { useState } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import BottomNav from '../component/BottomNav';
import contactImg from '../assets/images/contact.png';
import logo from '../assets/images/PlacezioLogo.png';
import { API_URL } from '../common/constant';
import { Helmet } from 'react-helmet';
import WhatsAppButton from '../component/Whatsappbtn';

const Requirements = () => {
    const [formData, setFormData] = useState({
        name: '',
        mobile: '',
        email: '',
        gender: '',
        purpose: '',
        requirement: '',
    });

    console.log('gender', formData?.gender)

    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});

    // Validation Functions
    const validateName = (name) => /^[a-zA-Z\s]{3,}$/.test(name) ? '' : 'Name must be at least 3 characters and contain only letters.';
    const validateMobile = (mobile) => /^\d{10}$/.test(mobile) ? '' : 'Enter a valid 10-digit mobile number.';
    const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) ? '' : 'Please enter a valid email address.';

    const handleChange = (e) => {
        const { name, value } = e.target;
        let error = '';

        if (name === 'name') error = validateName(value);
        else if (name === 'mobile') error = validateMobile(value);
        else if (name === 'email') error = validateEmail(value);

        setFormData({ ...formData, [name]: value });
        setErrors({ ...errors, [name]: error });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        const { name, mobile, email, gender, purpose, requirement } = formData;

        if (errors.name || errors.mobile || errors.email || !requirement || !gender || !purpose) {
            toast.error('Please fill out the form correctly.');
            setLoading(false);
            return;
        }

        const requirementData = { name, mobileNumber: mobile, email, gender, purpose, requirement };

        try {
            console.log('Submitting data:', requirementData);
            const response = await axios.post(`${API_URL}/api/requirements`, requirementData);
            console.log('Success:', response.data);
            toast.success('Your requirements have been submitted successfully!');
            setFormData({ name: '', mobile: '', email: '', gender: '', purpose: '', requirement: '' });
        } catch (error) {
            console.error('Error:', error);
            toast.error('Failed to submit your requirements. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Helmet>
                <title>Contact Us | Placezio Estate</title>
                <meta name="description" content="Submit your property requirements or inquire about flats for rent and sale at Placezio Estate. Get personalized assistance with your real estate needs." />
                <meta property="og:image" content={logo} />
                <meta property="og:url" content="https://placezioestate.com/requirements" />
                <link rel="canonical" href="https://placezioestate.com/requirements" />
            </Helmet>

            <div className="text-center max-w-7xl mx-auto px-4 py-8">
                <ToastContainer />
                <h3 className="text-2xl sm:text-3xl md:text-4xl  text-[#54BD95]">Love to hear your requirement</h3>
                <h3 className="text-xl sm:text-3xl md:text-4xl  mb-8 text-[#54BD95] mt-4"> Looking For Rent | Sale | Buy</h3>
                <div className='text-center'><h1 className='my-10 text-[#54BD95]'>────୨ৎ────</h1></div>

                <div className="flex flex-col lg:flex-row gap-10 w-full">
                    {/* Contact Form Section */}
                    <section className="lg:w-2/3 w-full">
                        <form onSubmit={handleSubmit} className="space-y-6 p-6 bg-white rounded-lg shadow-lg hover:shadow-2xl transition-shadow duration-300">
                            <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Your Name" autoComplete='off'
                                className="w-full p-4 border border-gray-300 rounded-md focus:ring-[#54BD95] focus:border-[#54BD95]" />
                            {errors.name && <p className="text-red-500 text-sm">{errors.name}</p>}

                            <input type="tel" name="mobile" value={formData.mobile} onChange={handleChange} placeholder="Mobile Number" autoComplete='off'
                                className="w-full p-4 border border-gray-300 rounded-md focus:ring-[#54BD95] focus:border-[#54BD95]" />
                            {errors.mobile && <p className="text-red-500 text-sm">{errors.mobile}</p>}

                            <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="Email Address" autoComplete='off'
                                className="w-full p-4 border border-gray-300 rounded-md focus:ring-[#54BD95] focus:border-[#54BD95]" />
                            {errors.email && <p className="text-red-500 text-sm">{errors.email}</p>}

                            {/* Gender Dropdown */}
                            {/* Gender Dropdown */}
                            <select
                                name="gender"
                                value={formData.gender}
                                onChange={handleChange}
                                className={`w-full p-4 border border-gray-300 rounded-md focus:ring-[#54BD95] focus:border-[#54BD95] ${formData.gender ? "text-black" : "text-gray-400"
                                    }`}
                            >
                                <option value="">Select Gender</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                                <option value="Other">Other</option>
                            </select>

                            {/* Purpose Dropdown */}
                            <select
                                name="purpose"
                                value={formData.purpose}
                                onChange={handleChange}
                                className={`w-full p-4 border border-gray-300 rounded-md focus:ring-[#54BD95] focus:border-[#54BD95] ${formData.purpose ? "text-black" : "text-gray-400"
                                    }`}
                            >
                                <option value="">Select Purpose</option>
                                <option value="For Rent">For Rent</option>
                                <option value="For Purchase">For Purchase</option>
                                <option value="Other Purpose">Other Purpose</option>

                            </select>


                            <textarea name="requirement" value={formData.requirement} onChange={handleChange} placeholder="I need a 2BHK flat in Ansal, Lucknow" required rows="4"
                                className="w-full p-4 border border-gray-300 rounded-md focus:ring-[#54BD95] focus:border-[#54BD95]"></textarea>

                            <button type="submit" disabled={loading}
                                className={`w-full py-3 rounded-md shadow-lg ${loading ? 'bg-gray-500 cursor-not-allowed' : 'bg-[#54BD95] text-white hover:bg-opacity-80'}`}>
                                {loading ? 'Submitting...' : 'Submit'}
                            </button>
                        </form>
                    </section>

                    {/* Contact Information Section */}
                    <section className="lg:w-3/4 w-full p-10 bg-white rounded-lg shadow-lg hover:shadow-2xl transition-shadow duration-300">
                        {/* How It Works Section */}
                        <div className="mt-10">
                            <h3 className="text-2xl font-extrabold text-[#54BD95] mb-6 text-center">How It Works</h3>

                            <div className="space-y-8">
                                {/* Step 1 */}
                                <div className="flex flex-col sm:flex-row items-center sm:items-start gap-4 text-center sm:text-left">
                                    <span className="text-5xl">📝</span>
                                    <div>
                                        <h4 className="text-xl font-bold">Step 1: Submit Your Requirement</h4>
                                        <p className="text-gray-600">Fill out the form with your property details, location, and preferences.</p>
                                    </div>
                                </div>

                                {/* Step 2 */}
                                <div className="flex flex-col sm:flex-row items-center sm:items-start gap-4 text-center sm:text-left py-8">
                                    <span className="text-5xl">📞</span>
                                    <div>
                                        <h4 className="text-xl font-bold">Step 2: Our Team Will Contact You</h4>
                                        <p className="text-gray-600">One of our team members will reach out to you within 24 hours.</p>
                                    </div>
                                </div>

                                {/* Step 3 */}
                                <div className="flex flex-col sm:flex-row items-center sm:items-start gap-4 text-center sm:text-left">
                                    <span className="text-5xl">🏡</span>
                                    <div>
                                        <h4 className="text-xl font-bold">Step 3: Get Your Required Property</h4>
                                        <p className="text-gray-600">We will find the best available options matching your requirements.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                </div>
            </div>
            <WhatsAppButton />
            <BottomNav />
        </>
    );
};

export default Requirements;
